module.exports = __webpack_public_path__ + "img/2.460d9187.jpg";